import type { Vec2 } from './types';

export const distanceSquared = (a: Vec2, b: Vec2): number => {
  const dx = b.x - a.x;
  const dy = b.y - a.y;
  return dx * dx + dy * dy;
};

export const angleTo = (from: Vec2, to: Vec2): number => Math.atan2(to.y - from.y, to.x - from.x);

export const wrapAngle = (angle: number): number => {
  let result = angle;
  while (result > Math.PI) result -= Math.PI * 2;
  while (result < -Math.PI) result += Math.PI * 2;
  return result;
};

export const approachAngle = (current: number, target: number, step: number): number => {
  const delta = wrapAngle(target - current);
  if (Math.abs(delta) <= step) return target;
  return current + Math.sign(delta) * step;
};

export const moveTowards = (from: Vec2, to: Vec2, amount: number): Vec2 => {
  const dx = to.x - from.x;
  const dy = to.y - from.y;
  const length = Math.hypot(dx, dy);
  if (length === 0 || length <= amount) return { x: to.x, y: to.y };
  return { x: from.x + (dx / length) * amount, y: from.y + (dy / length) * amount };
};
